<template>
  <div class="home px-2 overflow-hidden">
    <vue-headful :title="title"/>
    <div class="container mx-auto">
      <div class="flex flex-wrap -mx-4 items-end border-b py-5">
        <div class="w-full md:w-1/4 px-4">
          <img style="max-height: 120px;" v-if="logoString" :src="`data:image/jpeg;base64,${logoString}`" alt="">
        </div>
        <div class="w-full md:w-3/4 px-4 mt-5 md:mt-0">
          <div v-if="agency" class="agenzia px-5 font-light text-sm md:text-base text-right">
            <p class="uppercase text-base md:text-xl mb-2 font-bold">{{ agency.Cognome }} {{ agency.Nome }}</p>
            <p>{{ agency.Indirizzo}}<span v-if="agency.Civico">, {{agency.Civico}}</span>
              <!--<span v-if="agency.ID_Cap"> - {{agency.ID_Cap}}</span>-->
            </p>
            <p v-for="(telefono, index) in agency.Telefoni" :key="'t'+index">
              <a :href="'tel:0039'+telefono.Numero">{{ telefono.Etichetta}} - {{telefono.Numero}}</a>
            </p>
            <p v-for="(email, index) in agency.Email" :key="'e'+index">
              <a :href="'mailto:'+email.Numero">{{ email.Etichetta}} - {{email.Numero}}</a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="container mx-auto">
      <immobile
          v-if="item"
          :current-immobile="item"
          :attachments="attachments"
          :planimetrie="planimetrie"
          :videos="videos"
          :hasVideo="hasVideo"
          :plans="plans"
          :agency="agency"
          :commons="commons"
      />
    </div>
  </div>
</template>

<script>
import {HttpCommons} from "../http-commons";
import Immobile from "../components/Immobile";
import {arrayBufferToBase64} from "../http-commons";

export default {
  name: "Home",
  data: function () {
    return {
      item: null,
      attachments: null,
      plans: null,
      planimetrie: null,
      hasVideo: null,
      videos: [],
      agency: null,
      commons: null,
      quartiere: null,
      zona: null,
      logoString: null,
    };
  },
  computed: {
    title() {
      return this.agency ? `${this.agency.Cognome} ${this.agency.Nome}` : "";
    },
  },
  components: {
    Immobile,
  },
  methods: {
    getVideoSrc($id) {
      return this.commons.videoSrc($id);
    },
  },
  beforeMount() {
    this.commons = new HttpCommons(this.$route.params.guid);

    const callForItem = this.commons.HTTP.get(
        "?$expand=Piano,Comune,Quartiere,Zona,Caratteristiche($Expand=Descrizione),TipologiaOfferta,TipologiaOffertaSubordinata,TipoArredamento,TipoRiscaldamento,TipoGarage,TipoGiardino,ClasseEnergetica,TipologiaCucina,Consistenze($Expand=Consistenze($Expand=Descrizione($Select=Voce)),Piani),TipoStatoConservazioneImmobile,StatoConservazioneEdificio,Caratteristiche($Expand=Descrizione)"
    );
    const callForAttachments = this.commons.HTTP.get("/Allegati");

    const callForAgencyInfos = this.commons.TESTHTTP.get(`/Ufficio(key=${this.$route.params.guid})`);

    Promise.all([callForItem, callForAttachments, callForAgencyInfos])
        .then(
            (values) => {
              this.item = values[0].data;
              this.agency = values[2].data;

              this.commons.axios.get(`https://fhservices2.azurewebsites.net/UfficioImageURL(idufficio=${this.item.ID_UfficioMittente},categoria=1)`, {
                responseType: "arraybuffer"
              })
              .then(resp => {
                this.logo = resp.data
                if (arrayBufferToBase64(resp.data)) {
                  this.logoString = arrayBufferToBase64(resp.data)
                }
              })

              const attachments = values[1].data.value;

              const videos = attachments.filter(
                  (item) => item.TipoRisorsa === "Video"
              );

              if (videos.length)
                this.hasVideo = true

              this.attachments = attachments.filter(
                  (item) => item.TipoRisorsa === "Immagine"
                      && item.Tipo !== "Planimetria"
              );
              this.planimetrie = this.plans = attachments.filter(
                  (item) => item.TipoRisorsa === "Immagine"
                      && item.Tipo === "Planimetria"
              );
              this.plans = attachments.filter((item) => item.TipoRisorsa === "Pdf");

              videos.map((video) => {
                this.commons.HTTP.get(this.getVideoSrc(video.IDPubblico)).then(
                    (r) => {
                      this.videos.push({
                        id: r.data.idYouTubeVideo,
                        thumbnail: r.data.uriThumbnail,
                      });
                    }
                );
              });
            }
        ).catch(e => {
      console.error(e)
    });
  },
};
</script>
